<template>
  <div class="user">
    <div class="photo">
      <md-icon style="margin-left:5px; color: #FFF">perm_identity</md-icon>
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li v-for="group in groups" v-bind:key="group">
                <a href="#" @click="SET_GROUP_SELECTED(group)">
                  <span class="sidebar-mini">{{ group.substring(0, 3)}}</span>
                  <span class="sidebar-normal">{{ group }}</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: "Client",
    },
    rtlTitle: {
      type: String,
      default: "تانيا أندرو",
    },
    avatar: {
      type: String,
      default: "./img/faces/avatar.jpg",
    },
  },
  data() {
    return {
      isClosed: true,
      groups: [],
    };
  },
  async mounted() {
    var payload = await this.$auth.getPayload();
    this.groups = payload["https://acqgroups.cloud/groups"];
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    ...mapMutations(["SET_GROUP_SELECTED"])
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
